import {
    hideFromMenuItemsIfNotAllowed,
    menuItems, menuItemsNoAuth,
    menuItemsNoAuthWMain,
    swapMenuItemsClosedRegistrationToOpenIfAllowed
} from "@/plugins/router";
import {store} from "@/scripts/globals";

export default {
    props: ['isAuthenticated'],
    data() {
        return {
            menuItemsNoAuth: swapMenuItemsClosedRegistrationToOpenIfAllowed(menuItemsNoAuth, this.$route),
            menuItemsNoAuthWMain: swapMenuItemsClosedRegistrationToOpenIfAllowed(menuItemsNoAuthWMain, this.$route),
            store
        };
    },
    computed: {
        menuItems () {
            return hideFromMenuItemsIfNotAllowed(menuItems)
        },
    }
};